import { Component } from "@angular/core";

@Component({
  selector: "app-splash",
  standalone: true,
  templateUrl: "./splash.component.html",
  styleUrls: ["./splash.component.scss"],
})
export default class SplashComponent {
  isVisible = true;

  constructor() {
    console.log("SplashComponent");
    this.hideSplashAfterDelay();
  }

  hideSplashAfterDelay() {
    setTimeout(() => {
      this.isVisible = false;
    }, 1000);
  }
}
